import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContainer = styled.div`
  background: #fff;
  width: 95%;
  max-width: 1400px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #dee2e6;
  background: #f8f9fa;

  h2 {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #212529;
  }
`;

export const ModalBody = styled.div`
  padding: 24px;
  overflow-y: auto;
  flex: 1;
`;

export const ModalDescription = styled.p`
  margin: 0 0 20px 0;
  color: #6c757d;
  font-size: 14px;
  line-height: 1.5;
`;

export const ModalFooter = styled.div`
  padding: 16px 24px;
  border-top: 1px solid #dee2e6;
  background: #f8f9fa;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #6c757d;
  transition: color 0.3s ease;
  line-height: 1;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #495057;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  flex-direction: column;
`;

export const ConfirmButton = styled.button`
  flex: 1;
  background: #595959;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    background: #404040;
  }

  &:active {
    background: #404040;
  }
`;

export const CancelButton = styled.button`
  flex: 1;
  background: #1a1a1a;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    background: #2f2f2f;
  }

  &:active {
    background: #2f2f2f;
  }
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  overflow: hidden;
`;

export const TableHeader = styled.thead`
  background: #f8f9fa;
  
  th {
    font-weight: 600;
    color: #495057;
    text-align: left;
    border-bottom: 2px solid #dee2e6;
  }
`;

export const TableBody = styled.tbody`
  tr:nth-child(even) {
    background: #f8f9fa;
  }

  tr:hover {
    background: #e9ecef;
  }
`;

export const TableRow = styled.tr`
  border-bottom: 1px solid #dee2e6;

  &:last-child {
    border-bottom: none;
  }
`;

export const TableCell = styled.td`
  padding: 12px 16px;
  font-size: 14px;
  color: #212529;
  border-right: 1px solid #dee2e6;

  &:last-child {
    border-right: none;
  }
`;

export const CheckboxCell = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  input[type='checkbox'] {
    width: 18px;
    height: 18px;
    cursor: pointer;
    accent-color: #595959;
  }
`;
